import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Typography } from '@telus-uds/components-web';

import { FormBox } from '../../../css';

const SelectField = ({
  label,
  errors = {},
  touched = {},
  name,
  id = null,
  list,
  allowOptionNull = null,
  errorIcon = null,
  val
}) => {
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <Typography block heading="h4" variant={{ size: 'h4' }}>{label}</Typography>
      </div>
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${errors[name] && touched[name] ? 'error' : ''
          }`}
      >
        <Field as="select" id={id} name={name} className="select-style">
          {allowOptionNull && <option value={null} />}
          {list.map(l => (
            <option key={l.id} value={l.id}>
              {l[val]}
            </option>
          ))}
        </Field>
        <div className="error_messages">
          <Typography variant={{ colour: 'error' }}>{errors[name]}</Typography>
        </div>
        <div id="username_error_icon" className="error_messages_icon">
          <img src={errorIcon} alt="error_icon" />
        </div>
      </div>
    </FormBox>
  );
};

SelectField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  touched: PropTypes.objectOf(PropTypes.bool),
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  errorIcon: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  allowOptionNull: PropTypes.bool,
  val: PropTypes.string.isRequired
};

export default SelectField;
